import { render, staticRenderFns } from "./EditHistoryModal.vue?vue&type=template&id=3b617f88&scoped=true&"
import script from "./EditHistoryModal.vue?vue&type=script&lang=js&"
export * from "./EditHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./EditHistoryModal.vue?vue&type=style&index=0&id=3b617f88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b617f88",
  null
  
)

export default component.exports